import { render } from "./Admin.Shop.vue?vue&type=template&id=0df54309"
import script from "./Admin.Shop.vue?vue&type=script&lang=js"
export * from "./Admin.Shop.vue?vue&type=script&lang=js"

import "./Admin.Shop.vue?vue&type=style&index=0&id=0df54309&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__